export const isCreditCustomerCheckoutTender = (tender) => {
    return (tender.tender_type === 'CREDIT' &&
        tender.customer_card_id !== undefined);
};
export const isCreditGuestCheckoutTender = (tender) => {
    return (tender.tender_type === 'CREDIT' &&
        tender.acct !== undefined);
};
export const isGiftCardCheckoutTender = (tender) => {
    return tender.tender_type === 'GIFT_CARD';
};
export const isHouseAccountCheckoutTender = (tender) => {
    return tender.tender_type === 'HOUSE_ACCOUNT';
};
export const isApplePayCheckoutTender = (tender) => {
    return tender.tender_type === 'APPLE_PAY';
};
export const isGooglePayCheckoutTender = (tender) => {
    return tender.tender_type === 'GOOGLE_PAY';
};
